export default function getFromStorage(key = '', defaultVal = false) {
  if (window.hasStorage) {
    const val = localStorage.getItem(key);
    let parsed;
    try {
      parsed = (val && JSON.parse(val)) || defaultVal;
    } catch (e) {
      parsed = defaultVal;
      // eslint-disable-next-line no-console
      console.warn('Failed to parse: ', val);
    }
    return parsed;
  }

  return defaultVal;
}
